import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { useAuthentication } from '@/hooks/auth/useAuthentication';
import { PasswordResetComplete } from '@/pages/password/PasswordResetComplete/PasswordResetComplete';
/**
 * パスワード再設定完了（認証制限）
 */
export const PasswordResetCompleteAuth = () => {
    // 認証周りの判定取得
    const { message: authRedirectMessage, redirectTo: authRedirectTo } = useAuthentication({ isGuest: true });
    // リダイレクト: ユーザー認証
    if (authRedirectTo) {
        return _jsx(CustomRedirect, { message: authRedirectMessage, to: authRedirectTo });
    }
    return _jsx(PasswordResetComplete, {});
};
